import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from './BoundingBoxesFragment'
import { MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT } from './MultiProductImageProductFragment'

export const MULTI_PRODUCT_IMAGE_FRAGMENT = gql`
  fragment MultiProductImage on MultiProductImage {
    id
    url
    upcSet
    boundingBoxSet {
      ...BoundingBoxes
    }
    products {
      ...MultiProductImageProduct
    }
  }
  ${BOUNDING_BOXES_FRAGMENT}
  ${MULTI_PRODUCT_IMAGE_PRODUCT_FRAGMENT}
`
